import { apiErrorMessage } from './ApiError';
import { axiosApi } from './axios.api';
import { MovementDataArray, MovementModel, MovementQueryParams } from '@app/interfaces/movement';

const url = `/api/movements`;

export const getMovementsApi = async (params: MovementQueryParams): Promise<MovementDataArray | undefined> => {
  try {
    const response = await axiosApi.get<MovementDataArray>(url, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getMovementApi = async (inventoryMovementId: number) => {
  try {
    const response = await axiosApi.get(`${url}/${inventoryMovementId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createMovementApi = async (data: MovementModel, config: any) => {
  try {
    const response = await axiosApi.post(url, data, config);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateMovementApi = async (movementId: number, formData: MovementModel, config: any) => {
  try {
    const response = await axiosApi.put(`${url}/${movementId}`, formData, config);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteMovementApi = async (inventoryMovementId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${inventoryMovementId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const postMovementApi = async (inventoryMovementId: number) => {
  try {
    const response = await axiosApi.post(`${url}/${inventoryMovementId}/post`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const removeDocumentMovementApi = async (inventoryMovementId: number, documentId: number) => {
  try {
    const response = await axiosApi.post(`${url}/${inventoryMovementId}/remove_document`, {document_id: documentId});
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportMovementApi = async (params?: string) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `movements.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getMovementFiltersApi = async (params: any) => {
  try {
    const response = await axiosApi.get(`${url}/filters`, params);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export interface MovementStatsParams {
  from_date?: string;
  to_date?: string;
  period?: 'month' | 'quarter' | 'year';
  supplier_id?: number;
  movement_type?: string;
}

export interface MovementStatsRow {
  period: string;
  type: string;
  qty: number;
  amount: number;
}

export interface MovementTopSupplier {
  name: string;
  in_qty: number;
  in_amount: number;
  out_qty: number;
  out_amount: number;
  debit: number;
}

export interface MovementStatsData {
  rows: MovementStatsRow[];
  summary: {
    goods_receive:   { qty: number; amount: number };
    return_supplier: { qty: number; amount: number };
  };
  top_suppliers: MovementTopSupplier[];
}

export const getMovementStatsApi = async (params: MovementStatsParams): Promise<MovementStatsData | undefined> => {
  try {
    const response = await axiosApi.get<MovementStatsData>(`${url}/stats`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getMovementDraftsApi = async (params: MovementQueryParams): Promise<MovementDataArray | undefined> => {
  try {
    const response = await axiosApi.get<MovementDataArray>(`${url}/draft`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};